// Payment can finish in another tab without remounting the original page.
export function installDepositResume (store) {
  let checking = false
  const finished = () => { checking = false }
  const resume = () => {
    if (document.visibilityState === 'hidden' || !store.state.isLogin || checking) return
    checking = true
    try {
      Promise.resolve(store.dispatch('reportDepositEvents')).then(finished, finished)
    } catch (error) { finished() }
  }
  window.addEventListener('focus', resume)
  document.addEventListener('visibilitychange', resume)
  return () => {
    window.removeEventListener('focus', resume)
    document.removeEventListener('visibilitychange', resume)
  }
}



// WEBPACK FOOTER //
// ./src/common/utils/depositResume.js